import axios from "axios";

// La URL base del backend API, leída de las variables de entorno
const API_URL =
  process.env.REACT_APP_BACKEND_API_URL || "/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor de request: añade el token JWT a las cabeceras si está disponible
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // O de donde almacenes el token (ej. Context)
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Puedes añadir un interceptor de respuesta para manejar errores globales (ej. 401 Unauthorized)

export default api;
